import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchRecentsList'

export default defineMessages({
  recentHeading: {
    id: `${scope}.recentHeading`,
    defaultMessage: 'Recent',
  },
  listboxAriaLabel: {
    id: `${scope}.listboxAriaLabel`,
    defaultMessage: 'Recent searches',
  },
})
